import { useTranslation } from "react-i18next";
import { useMunicipalityStore } from "../../store";
import { ActionsTable } from "Common/Components";
import { useMemo, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { DeleteMunicipality, FetchMunicipality } from "services";
import { Municipality } from "interfaces";
import { NotificationType, showNotifications } from "helpers/toas_notification";

export const useMunicipalityList = () => {
  const { t } = useTranslation();
  const { setIsEdit, setIsOpenModal, setMunicipality, clearAll } =
    useMunicipalityStore();
  const [modalDelete, setModalDelete] = useState<boolean>(false);
  const [idMunicipality, setIdMunicipality] = useState<number | null>(null);
  const [isSubmiting, setIsSubmiting] = useState<boolean>(false);

  const columns = useMemo(
    () => [
      {
        header: "ID",
        accessorKey: "index",
        cell: (cell: any) => cell.row.index + 1,
        enableColumnFilter: false,
      },
      {
        header: t("municipality.table.columns.code"),
        accessorKey: "code",
        enableColumnFilter: false,
      },
      {
        header: t("municipality.table.columns.description"),
        accessorKey: "description",
        enableColumnFilter: false,
      },
      {
        header: t("municipality.table.columns.department"),
        accessorKey: "departament.description",
        enableColumnFilter: false,
      },
      {
        header: t("municipality.table.columns.actions"),
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell: any) => {
          const rowData = cell.row.original;
          return (
            <ActionsTable
              onClickEdith={() => handleEdit(rowData)}
              onClickDelete={() => handleDelete(rowData)}
            />
          );
        },
      },
    ],
    [t]
  );

  const { data, refetch: refetchMunicipality } = useQuery({
    queryKey: ["municipality"],
    queryFn: FetchMunicipality,
  });

  const handleEdit = (item: Municipality) => {
    setIsEdit(true);
    setMunicipality(item);
    setIsOpenModal(true);
  };

  const handleDelete = (item: Municipality) => {
    setIdMunicipality(item.id);
    setModalDelete(true);
  };

  const deleteMunicipality = async () => {
    try {
      setIsSubmiting(true);
      if (idMunicipality === null) return;
      const response = await DeleteMunicipality(idMunicipality);
      if (response.code === "200") {
        setModalDelete(false);
        refetchMunicipality();
        showNotifications(
          NotificationType.SUCCESS,
          t("deleteModal.succedDelete")
        );
      } else {
        showNotifications(
          NotificationType.ERROR,
          t("deleteModal.errorDelete" + response.message)
        );
      }
    } catch (error) {
      showNotifications(NotificationType.ERROR, t("deleteModal.errorDelete"));
    } finally {
      setIsSubmiting(false);
    }
  };

  return {
    t,
    columns,
    municipalityList: data?.data,
    refetchMunicipality,
    setIsOpenModal,
    setMunicipality,
    modalDelete,
    setModalDelete,
    deleteMunicipality,
    clearAll,
    isSubmiting,
  };
};
